/* spx-lazy-strict.js — strict IntersectionObserver image lazy-loading (2026-07-05).
   Chrome's native loading="lazy" fetches almost everything on slow connections
   (multi-thousand-px threshold), starving the LCP hero. Images converted to
   data-spx-src/data-spx-srcset only load within 600px of the viewport.
   Side benefit: display:none variants (desktop/mobile twins) never intersect,
   so hidden duplicates never download; on resize/orientation they load on demand.
   No-IO browsers and print get an immediate full swap. */
(function () {
  'use strict';
  function swap(img) {
    var ss = img.getAttribute('data-spx-srcset');
    if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-spx-srcset'); }
    var s = img.getAttribute('data-spx-src');
    if (s) { img.setAttribute('src', s); img.removeAttribute('data-spx-src'); }
  }
  function init() {
    var imgs = [].slice.call(document.querySelectorAll('img[data-spx-src], img[data-spx-srcset]'));
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < imgs.length; i++) swap(imgs[i]);
      return;
    }
    /* When one image in a section intersects, swap every held image in that
       section that participates in layout (offsetParent !== null). Horizontal
       carousels load their whole strip the moment the section nears the
       viewport instead of popping in mid-swipe. display:none twins
       (desktop/mobile variants) stay held — they swap individually via IO if
       a resize ever reveals them. */
    function swapGroup(target) {
      io.unobserve(target);
      swap(target);
      var sec = target.closest ? target.closest('.shopify-section, section, [data-section-id]') : null;
      if (!sec) return;
      var held = sec.querySelectorAll('img[data-spx-src], img[data-spx-srcset]');
      for (var g = 0; g < held.length; g++) {
        var el = held[g];
        /* keep only the deliberate responsive twins held (class contains
           desktop/mobile AND currently hidden) — everything else in the
           section swaps now, including carousel items the carousel JS has
           temporarily display:none'd off-rotation */
        var isTwin = /desktop|mobile/i.test(el.className) && el.offsetParent === null;
        if (!isTwin) { io.unobserve(el); swap(el); }
      }
    }
    var io = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        if (entries[j].isIntersecting) swapGroup(entries[j].target);
      }
    }, { rootMargin: '600px 1200px' }); /* wide horizontal margin: carousel items translated off-axis load a beat early */
    for (var k = 0; k < imgs.length; k++) io.observe(imgs[k]);
    window.addEventListener('beforeprint', function () {
      for (var m = 0; m < imgs.length; m++) swap(imgs[m]);
    });

    /* Brilliant-Earth-style post-load streaming (2026-07-05): once the page is
       fully loaded and the browser is idle, stream the remaining held images in
       small low-priority batches — so by the time the shopper scrolls, content
       is already there (no pop-in), while the critical window stayed untouched.
       Hidden desktop/mobile twins stay held (they'd be wasted bytes). */
    function streamRest() {
      var held = [].slice.call(document.querySelectorAll('img[data-spx-src], img[data-spx-srcset]')).filter(function (el) {
        return !(/desktop|mobile/i.test(el.className) && el.offsetParent === null);
      });
      if (!held.length) return;
      var i = 0;
      function batch() {
        for (var n = 0; n < 4 && i < held.length; n++, i++) {
          try { held[i].setAttribute('fetchpriority', 'low'); } catch (e) {}
          io.unobserve(held[i]);
          swap(held[i]);
        }
        if (i < held.length) setTimeout(batch, 350);
      }
      batch();
    }
    window.addEventListener('load', function () {
      if (window.requestIdleCallback) requestIdleCallback(streamRest, { timeout: 4000 });
      else setTimeout(streamRest, 2500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
